import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useBranding } from '../../contexts/BrandingContext';

import CommercialDeviceTable from './CommercialDeviceTable';
import PersonalDeviceTable from './PersonalDeviceTable';

/**
 * Device Listing function Component
 * @returns
 */
function DeviceListing() {
  const [searchParameters] = useSearchParams();
  const chargerType = searchParameters.get('chargerType');
  const [currentPage, setCurrentPage] = useState<string>(chargerType || 'commercial');
  const { brandData } = useBranding();

  useEffect(() => {
    if (chargerType) {
      setCurrentPage(chargerType);
    }
  }, [chargerType]);
  return (
    <div className="body-container">
      <div className="table-content">
        {currentPage === 'commercial' && (
          <CommercialDeviceTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
        {currentPage === 'personal' && !brandData?.useSharedDatabase &&(
          <PersonalDeviceTable setCurrentPage={setCurrentPage} currentPage={currentPage} />
        )}
      </div>
    </div>
  );
}

export default DeviceListing;
